import React from "react";
import { Check, ArrowRight, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

const PricingSection: React.FC = () => {
  return <section className="section-spacing bg-white" id="pricing">
      <div className="container">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm animate-fade-in">
            Investition
          </span>
          <h2 className="animate-fade-in" style={{
          animationDelay: '100ms'
        }}>
            Deine Investition in neue Perspektiven
          </h2>
          <p className="mt-4 text-joerg-600 animate-fade-in" style={{
          animationDelay: '200ms'
        }}>
            Ein strukturiertes Format für nachhaltige Veränderungen und neue Blickwinkel
          </p>
        </div>

        <div className="max-w-3xl mx-auto animate-fade-in">
          <div className="bg-white rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 p-6 md:p-8 border-2 border-[#B6D0AE]">
            <div className="md:flex gap-8 items-center">
              <div className="md:w-3/5 text-left mb-6 md:mb-0">
                <h3 className="text-2xl font-semibold text-joerg-800 mb-4">Outdoor-Coaching am Rothsee</h3>
                
                <p className="text-joerg-600 text-left mb-6">Das Outdoor-Coaching am wunderschönen Rothsee verbindet die Kraft der Natur mit professionellem Coaching. In 90-minütigen Walk & Talk Sessions eröffnen sich neue Blickwinkel auf Ihre Themen, beruflich wie persönlich.</p>
                
                <div className="mb-6">
                  <ul className="space-y-3 text-joerg-600 text-left">
                    <li className="flex items-start gap-3">
                      <Check className="h-5 w-5 text-[#2F855A] flex-shrink-0 mt-0.5" />
                      <span>90-minütige Walk & Talk Session am Rothsee</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <Check className="h-5 w-5 text-[#2F855A] flex-shrink-0 mt-0.5" />
                      <span>Kurze schriftliche Zusammenfassung der Ergebnisse</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <Check className="h-5 w-5 text-[#2F855A] flex-shrink-0 mt-0.5" />
                      <span>Follow-up per E-Mail innerhalb einer Woche</span>
                    </li>
                  </ul>
                </div>
                
                <div className="flex flex-col sm:flex-row justify-start gap-4">
                  <a href="https://zeeg.me/joerghoermann" target="_blank" rel="noopener noreferrer" className="btn-primary rounded-full inline-flex items-center mobile-touch-target justify-center bg-[#2F855A] hover:bg-[#276749] shadow-md hover:shadow-lg text-white">
                    Erstgespräch vereinbaren
                    <ExternalLink className="ml-2 h-4 w-4" />
                  </a>
                  
                  <Link to="/preise" className="btn-outline rounded-full inline-flex items-center justify-center border-[#2F855A] text-[#2F855A] hover:bg-[#2F855A]/10">
                    Alle Angebote ansehen
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Link>
                </div>
              </div>
              
              <div className="md:w-2/5 text-center bg-[#F7FBF4] p-5 rounded-lg border border-[#B6D0AE]/50">
                <div className="text-[#2F855A] font-medium uppercase text-sm mb-2">Ihr Investment</div>
                <div className="text-4xl font-bold text-[#2F855A] mb-1">199 €</div>
                <div className="text-joerg-600 text-sm mb-4">pro 90-Min. Session</div>
                <div className="text-sm text-joerg-600 mb-4">
                  <span className="inline-flex items-center gap-1">
                    inkl. 19% MwSt. gemäß §19 UStG
                  </span>
                </div>
              </div>
            </div>
            
            <div className="mt-6 pt-6 border-t border-[#B6D0AE]/30 bg-[#F7FBF4]/50 p-4 rounded-xl">
              <div className="flex items-start gap-2">
                <span className="text-[#2F855A] font-medium">Hinweis:</span>
                <span className="text-joerg-600 text-sm">
                  Bei schlechtem Wetter biete ich alternative Termine an oder wir weichen auf ein Indoor-Coaching aus. 
                  Langfristige Coaching-Pakete mit mehreren Outdoor-Sessions sind auf Anfrage verfügbar.
                </span>
              </div>
            </div>
          </div>
          
          <div className="mt-6 flex justify-center">
            <Link to="/preise" className="inline-flex items-center text-primary text-sm hover:text-primary-dark transition-colors">
              Alle Coaching-Formate ansehen
              <ArrowRight className="ml-1 h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
};
export default PricingSection;